import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { CalendarDays } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';
import { translations } from '../translations/common';

const HIDDEN_PATHS = ['/booking', '/admin', '/test'];

export const MobileBookingButton = () => {
  const { language } = useLanguage();
  const location = useLocation();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 400);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, [location.pathname]);

  if (HIDDEN_PATHS.some((p) => location.pathname.startsWith(p))) return null;

  return (
    <Link
      to="/booking"
      data-testid="mobile-booking-button"
      aria-label={translations[language].buttons.bookNow}
      className={`md:hidden fixed bottom-8 left-4 z-40 flex items-center gap-2 h-12 pl-4 pr-5 rounded-full bg-white/90 backdrop-blur-md border border-teal-100 text-teal-700 text-sm font-semibold shadow-lg transition-[opacity,transform] duration-300 ${
        visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4 pointer-events-none'
      }`}
    >
      <CalendarDays size={18} className="text-teal-600" />
      {translations[language].buttons.bookNow}
    </Link>
  );
};
